module.exports = __webpack_public_path__ + "img/WORD.ca9311f3.png";